import { Util, devLog } from "Util";
import { FetchManager, HOST } from "config";
import { create } from "zustand";

export interface ChatbotStoreType {
  getChatbotResponse: (message: string, signal?: AbortSignal) => Promise<any>;
}

const useChatbotAPIStore = create<ChatbotStoreType>((set) => ({
  async getChatbotResponse(question: string, signal?: AbortSignal) {
    try {
      const formData = new FormData();
      formData.append("question", question);

      const url = `${HOST}/gemma3`;
      const res = await FetchManager.post(url, formData, signal);
      const data = await Util.fetchAndSetData(res);

      if (data) return data;
      else throw new Error(res instanceof Error ? res.name : undefined);
    } catch (e: any) {
      devLog("[getChatbotResponse] 오류 발생", e);
      return { isSuccess: false, error: e.message };
    }
  },
}));

export default useChatbotAPIStore;
